import { createAsyncThunk } from "@reduxjs/toolkit"

import { API } from "redux/api"

export const fetchSubscriptionEligibility = createAsyncThunk(
  "client/subscription-eligibility/fetch",
  async () => {
    const response = await API.get("/client/subscription")
    return response.data
  },
)
